import { type RouteObject } from 'react-router-dom';

import { DashboardManagerBase } from './components/dashboard-manager-base/dashboard-manager-base';
import { Layout } from './components/layout/layout';
import { RouteErrorBoundary } from './components/route-boundary/route-boundary';
import NotFoundPage from './pages/not-found/not-found.page';

export const insightRoutes: RouteObject = {
  path: '/reports/dashboards/*',
  errorElement: <RouteErrorBoundary />,
  element: <Layout />,
  children: [
    {
      index: true,
      lazy: () =>
        import('./pages/dashboard-management/dashboard-management.page'),
    },
    {
      path: '*',
      element: <DashboardManagerBase />,
      children: [
        {
          path: 'new/*',
          lazy: () => import('./pages/insights-edit/insights-new.page'),
        },
        {
          path: ':dashboardId/*',
          children: [
            {
              index: true,
              lazy: () => import('./pages/dashboard/insights.page'),
            },
            {
              path: 'edit/*',
              lazy: () => import('./pages/insights-edit/insights-edit.page'),
            },
          ],
        },
        {
          path: '*',
          element: <NotFoundPage />,
        },
      ],
    },
  ],
};
